import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { useHistory } from "react-router-dom";
import { Panel } from "primereact/panel";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import { Calendars } from "../../../components/Calendar/Calendar";
import { validateInputText } from "../../../utilities/ValidateUtil";
import { formatDateAPI } from "../../../utilities/DateUtil";
import { FooterButtonSigleCustom } from "../../../components/FooterButton/FooterButton";
import ValidateService from "../../../components/ValidateService/ValidateService";
import { DialogConfirm } from "../../../components/DialogService/DialogService";

//PAGE
// List Table 5
import P412List_A from "./P412List_A";
import P412List_B from "./P412List_B";
import P412List_C from "./P412List_C";
import P412List_D from "./P412List_D";
import P412List_E from "./P412List_E";

// Dialog
import P413 from "../413/P413";
import P414 from "../414/P414";
import P415 from "../415/P415";
import P416 from "../416/P416";
import P417 from "../417/P417";

//CSS
import "../../../components/DataTable/DataTable.css";

//SERVICE
import { pCtContractInfo, pCtContractUpdate } from "../../../service/400/P412Service";
import { genContractorList, genContractTypeList, genBranchList, genBudgetTypeList, genContractStatusList } from "../../../service/GEN/GenService";

export default function P412() {
    const history = useHistory();
    const toast = useRef(null);

    const [loading, setLoading] = useState(false);

    //SEARCH
    const [dataSearch, setDataSearch] = useState({ action: "", contractNo: "", userId: dataUserSession() ? dataUserSession().userId : "" });

    // DATA
    const [errData, setErrData] = useState(null);
    const [formObject, setFormObject] = useState({ contractorCode: "" });

    const [date1, setDate1] = useState(new Date());
    const [date2, setDate2] = useState(new Date());
    const [date3, setDate3] = useState(new Date());

    const [dataTableA, setDataTableA] = useState([]);
    const [dataTableB, setDataTableB] = useState([]);
    const [dataTableC, setDataTableC] = useState([]);
    const [dataTableD, setDataTableD] = useState([]);
    const [dataTableE, setDataTableE] = useState([]);
    const [searchWord, setSearchWord] = useState("");
    const [contractNoS, setContractNoS] = useState("");

    const [submitted, setSubmitted] = useState(false);

    // DIALOG
    const [confirmDialog, setConfirmDialog] = useState(false);
    const [dialogOption, setdialogOption] = useState({
        header: "",
        content: "",
        onConfirm: () => { },
        onCancle: () => { },
        footerBtn: () => { },
    });
    const [dialog, setDialog] = useState({
        dialog_413: { open: false, action: "", dataSet: null },
        dialog_414: { open: false, action: "", dataSet: null },
        dialog_415: { open: false, action: "", dataSet: null },
        dialog_416: { open: false, action: "", dataSet: null },
        dialog_417: { open: false, action: "", dataSet: null },
    });

    // Dropdown
    const [dropItem, setDropItem] = useState({ contractorItem: [], contractTypeItem: [], branchItem: [], budgetTypeItem: [], contractStatusItem: [] });

    useEffect(() => {
        if (!dataUserSession()) {
            history.push("/login");
        } else {
            // console.log("Enter :", history.location.state.dataShr)
            if (history.location.state && history.location.state.dataShr) {
                setDataSearch({
                    ...dataSearch,
                    ...history.location.state.dataShr,
                });
                setSearchWord(history.location.state.dataShr.searchWord);
                setContractNoS(history.location.state.dataShr.contractNoS)
            } else {
                history.push("/411");
            }
        }
        loadDropDowm();
    }, []);

    useEffect(() => {
        if (dataSearch.action !== "") {
            onGetpCtContractInfo();
        }
    }, [dataSearch]);

    const onGetpCtContractInfo = () => {
        const req = {
            userId: dataSearch.userId,
            contractNo: dataSearch.contractNo,
        };
        pCtContractInfo(req).then(
            (res) => {
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            pipeLength :  element.pipeLength == null ? "" : element.pipeLength.toString().replace(".","+"),
                            index: index,
                        });
                        index++;
                    });

                    const t_1 = temp.filter((data) => {
                        return data.recordType === "1";
                    });
                    const t_2 = temp.filter((data) => {
                        return data.recordType === "2";
                    });
                    const t_3 = temp.filter((data) => {
                        return data.recordType === "3";
                    });
                    const t_4 = temp.filter((data) => {
                        return data.recordType === "4";
                    });
                    const t_5 = temp.filter((data) => {
                        return data.recordType === "5";
                    });
                    setDataTableA(t_1);
                    setDataTableB(t_2);
                    setDataTableC(t_3);
                    setDataTableD(t_4);
                    setDataTableE(t_5);

                    setDate1(temp[0].contractSignDate);
                    setDate2(temp[0].contractBeginDate);
                    setDate3(temp[0].contractEndDate);

                    setFormObject({ ...formObject, ...temp[0] });
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                if (err.response && err.response.data.status === 401) {
                    alert(JSON.stringify("เนื่องจาก Authorized หมดอายุ กรุณาเข้าสู่ระบบใหม่"));
                    window.location.href = "/login";
                }
                setLoading(false);
            }
        );
    };

    const loadDropDowm = async () => {
        const req = { userId: dataSearch.userId };

        let drop_1 = [];
        let drop_2 = [];
        let drop_3 = [];
        let drop_4 = [];
        let drop_5 = [];

        setLoading(true);
        await genContractorList(req).then(
            (res) => {
                drop_1.push(...res);
                setLoading(false);
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
        await genContractTypeList(req).then(
            (res) => {
                drop_2.push(...res);
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
        await genBranchList(req).then(
            (res) => {
                drop_3.push(...res);
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
        await genBudgetTypeList(req).then(
            (res) => {
                drop_4.push(...res);
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
        await genContractStatusList(req).then(
            (res) => {
                drop_5.push(...res);
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );

        setDropItem({ ...dropItem, contractorItem: drop_1, contractTypeItem: drop_2, branchItem: drop_3, budgetTypeItem: drop_4, contractStatusItem: drop_5 });
    };

    const footerButtonSingle = (orNo) => {
        const con = () => {
            handlerCloseDialog();
        };
        return <FooterButtonSigleCustom btnLabel="ตกลง" icon="pi pi-check" onClick={() => con()} />;
    };

    const handlerCloseDialog = () => {
        sessionStorage.setItem("P412_back", true)
        history.push({pathname: "411", state: {searchWord : searchWord, contractNoS : contractNoS}});
//   ,
//             history.push({
//                 pathname: "412",
//                 state: { dataShr: { contractNo: "", action: "NEW", searchWord, contractNoS } },
//             });
        setConfirmDialog({ open: false });
    };

    const handlerSettingDialogConfirm = (header, content) => {
        setdialogOption({
            ...dialogOption,
            header: header,
            content: content,
            footerBtn: () => footerButtonSingle(),
            onCancle: () => setConfirmDialog(false),
        });
        setConfirmDialog({ open: true });
    };

    const validation = (object) => {
        if (object.contractBranchCode === "" || object.poNo === "") {
            setSubmitted(true);
            return false;
        } else {
            setSubmitted(false);
            return true;
        }
    };
    const checkEmpty = (val) => {
        return val === undefined || val === "" || val === null ? "" : val;
    };

    const submitForm = (act) => {
        if (validation(formObject)) {
            const req = {
                actionCode: act,
                auc: checkEmpty(setViewForm("auc")),
                budgetType: checkEmpty(setViewForm("budgetType")),
                contractAmount: checkEmpty(setViewForm("contractAmount")),
                contractBeginDate: setViewForm("contractBeginDate") === "" ? "" : formatDateAPI(setViewForm("contractBeginDate"), false),
                contractBranchCode: setViewForm("contractBranchCode"),
                contractEndDate: setViewForm("contractEndDate") === "" ? "" : formatDateAPI(setViewForm("contractEndDate"), false),
                contractNo: dataSearch.contractNo,
                contractSignDate: setViewForm("contractSignDate") === "" ? "" : formatDateAPI(setViewForm("contractSignDate"), false),
                contractStatus: checkEmpty(setViewForm("contractStatus")),
                contractType: checkEmpty(setViewForm("contractType")),
                contractorCode: checkEmpty(filter(setViewForm("contractorName"))),
                fineRate: checkEmpty(setViewForm("fineRate")),
                poNo: checkEmpty(setViewForm("poNo")),
                contractPeriod:  checkEmpty(setViewForm("contractPeriod")),
                userId: dataSearch.userId,
            };

            pCtContractUpdate(req).then(
                (res) => {
                    setLoading(false);
                    handlerSettingDialogConfirm(res[0].statusCode === "C" ? "" : "", res[0].statusText);
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
        }
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const handlerOpenDialog = (key, _open, act, data) => {
        setDialog({ ...dialog, [key]: { open: _open, action: act, dataSet: data, contractNo: dataSearch.contractNo, userId: dataSearch.userId } });
    };

    const handlerAction = (rowData) => {
        handlerOpenDialog(`dialog_${rowData.target}`, true, rowData.action, rowData.data);
    };

    const setViewForm = (key) => {
        if (formObject !== null) return formObject[key] === "" || formObject[key] === null ? "" : formObject[key];
    };

    const setValueForm = (key, val) => {
        setFormObject({ ...formObject, [key]: val });
    };

    const filter = (val) => {
        for (const iterator of dropItem.contractorItem) {
            if (iterator.contractorName === val) {
                return iterator.contractorCode;
            }
        }
    };

    const onClickBack = () => {
        sessionStorage.setItem("P412_back", true)
        history.push("/411")
    }
    return (
        <>
            <ValidateService err={errData} setErr={setErrData} />
            <Loading loading={loading} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <h2 className="p-m-0">รายละเอียดสัญญา</h2>
                        <hr /> */}
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractNo">เลขที่สัญญา</label>
                                <InputText id="contractNo" placeholder="ระบุ เลขที่สัญญา" value={dataSearch.contractNo} onChange={(e) => setDataSearch({ ...dataSearch, contractNo: e.target.value })} maxLength={20} disabled={dataSearch.action === "EDIT" ? true : false} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractAmount">วงเงินสัญญา</label>
                                <InputNumber id="contractAmount" placeholder="ระบุ วงเงินสัญญา" useGrouping={false} max={9999999999} value={setViewForm("contractAmount")} onValueChange={(e) => setValueForm("contractAmount", e.value)} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractSignDate">วันที่ลงนามในสัญญา</label>
                                <Calendars
                                    key="contractSignDate"
                                    id="contractSignDate"
                                    value={date1 === "" ? null : new Date(date1)}
                                    onChange={(e) => {
                                        setDate1(e.target.value);
                                        setFormObject({ ...formObject, contractSignDate: e.target.value });
                                    }}
                                />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractPeriod">ระยะเวลา</label>
                                <InputText id="contractPeriod" placeholder="ระบุ ระยะเวลา" maxLength={20} value={setViewForm("contractPeriod")} onChange={(e) => setValueForm("contractPeriod", e.target.value)} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractBeginDate">วันที่เริ่มต้นสัญญา</label>
                                <Calendars
                                    key="contractBeginDate"
                                    id="contractBeginDate"
                                    value={date2 === "" ? null : new Date(date2)}
                                    onChange={(e) => {
                                        setDate2(e.target.value);
                                        setFormObject({ ...formObject, contractBeginDate: e.target.value });
                                    }}
                                />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="">วันที่สิ้นสุดสัญญา</label>
                                <Calendars
                                    key="contractEndDate"
                                    id="contractEndDate"
                                    value={date3 === "" ? null : new Date(date3)}
                                    onChange={(e) => {
                                        setDate3(e.target.value);
                                        setFormObject({ ...formObject, contractEndDate: e.target.value });
                                    }}
                                />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractorName">ชื่อบริษัทคู่สัญญา</label>
                                <Dropdown
                                    value={filter(setViewForm("contractorName"))}
                                    optionLabel="contractorName"
                                    optionValue="contractorCode"
                                    options={dropItem.contractorItem}
                                    placeholder="เลือก ชื่อบริษัทคู่สัญญา"
                                    filter
                                    onChange={(e) => {
                                        const _f = dropItem.contractorItem.filter((data) => {
                                            return e.value === data.contractorCode;
                                        });
                                        setFormObject({ ...formObject, contractorCode: e.target.value, contractorName: _f[0].contractorName });
                                    }}
                                />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractType">ประเภทสัญญา</label>
                                <Dropdown value={setViewForm("contractType")} optionLabel="contractTypeDesc" optionValue="contractTypeCode" options={dropItem.contractTypeItem} placeholder="เลือก ประเภทสัญญา" onChange={(e) => setValueForm("contractType", e.target.value)} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractBranchCode">สาขาเจ้าของสัญญา</label>
                                <Dropdown
                                    className={submitted && !formObject.contractBranchCode ? "p-invalid" : ""}
                                    value={setViewForm("contractBranchCode")}
                                    optionLabel="branchName"
                                    optionValue="branchCode"
                                    options={dropItem.branchItem}
                                    placeholder="เลือก สาขาเจ้าของสัญญา"
                                    onChange={(e) => setValueForm("contractBranchCode", e.target.value)}
                                />
                                {submitted && !formObject.contractBranchCode && validateInputText("contractBranchCode", "ประเภทสัญญา")}
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="budgetType">ประเภทงบประมาณ</label>
                                <Dropdown optionLabel="budgetTypeDesc" value={setViewForm("budgetType")} onChange={(e) => setValueForm("budgetType", e.target.value)} optionValue="budgetTypeCode" options={dropItem.budgetTypeItem} placeholder="เลือก ประเภทงบประมาณ" />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractStatus">สถานะโครงการ</label>
                                <Dropdown optionLabel="contractStatusDesc" value={setViewForm("contractStatus")} onChange={(e) => setValueForm("contractStatus", e.target.value)} optionValue="contractStatusCode" options={dropItem.contractStatusItem} placeholder="เลือก สถานะโครงการ" />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="fineRate">อัตราค่าปรับ(รายวัน)</label>

                                <InputNumber id="fineRate" mode="decimal" useGrouping={false} max={9999999999} minFractionDigits={2} maxFractionDigits={2} value={setViewForm("fineRate")} placeholder="ระบุ อัตราค่าปรับ(รายวัน)" onValueChange={(e) => setValueForm("fineRate", e.value)} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="poNo">เลขที่ PO</label>
                                <InputText placeholder="ระบุ เลขที่ PO" className={submitted && !formObject.poNo ? "p-invalid" : ""} maxLength={20} value={setViewForm("poNo")} onChange={(e) => setValueForm("poNo", e.target.value)} />
                                {submitted && !formObject.poNo && validateInputText("poNo", "เลขที่ PO")}
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="auc">AUC</label>
                                <InputText placeholder="ระบุ AUC" maxLength={20} value={setViewForm("auc")} onChange={(e) => setValueForm("auc", e.target.value)} />
                            </div>
                        </div>
                        <br />
                        <div className="p-grid" style={{ textAlign: "center" }}>
                            <div className="p-col-12">
                                <Button className="p-button-success p-button p-mr-2 p-mb-2" icon="pi pi-save" label="บันทึก" style={{ width: 170 }} onClick={() => submitForm(dataSearch.action === "NEW" ? "A" : "U")} />
                                <Button className="p-button-secondary p-button p-mr-2 p-mb-2" icon="pi pi-arrow-left" label="กลับหน้าจอแสดงรายการ" style={{ width: 200, marginLeft: "5px" }} onClick={() => onClickBack()} />
                                <Button className="p-button-danger p-button p-mr-2 p-mb-2" icon="pi pi-trash" label="ลบรายการ" style={{ marginLeft: "5px" }} onClick={() => submitForm("D")} disabled={dataSearch.action === "NEW" ? true : false} />
                            </div>
                        </div>
                        <hr />
                        <Panel header="รายละเอียดเส้นทาง" toggleable>
                            <P412List_A dataTable={dataTableA} setAction={handlerAction} setDis={dataSearch.action} />
                        </Panel>
                        <br />
                        <Panel header="รายชื่อคณะกรรมการตรวจรับพัสดุ" toggleable>
                            <P412List_B dataTable={dataTableB} setAction={handlerAction} setDis={dataSearch.action} />
                        </Panel>
                        <br />
                        <Panel header="รายชื่อผู้ควบคุมงาน" toggleable>
                            <P412List_C dataTable={dataTableC} setAction={handlerAction} setDis={dataSearch.action} />
                        </Panel>
                        <br />
                        <Panel header="รายชื่อบุคคลที่เกี่ยวข้องกับการบริหารสัญญาก่อสร้าง" toggleable>
                            <P412List_D dataTable={dataTableD} setAction={handlerAction} setDis={dataSearch.action} />
                        </Panel>
                        <br />
                        <Panel header="เอกสารที่เกี่ยวข้อง" toggleable>
                            <P412List_E dataTable={dataTableE} setAction={handlerAction} setDis={dataSearch.action} />
                        </Panel>
                    </div>
                </div>
            </div>
            {dialog.dialog_413.open === true ? (
                <>
                    <P413 dialog={dialog} setDialog={setDialog} onGetpCtContractInfo={onGetpCtContractInfo}/>
                </>
            ) : (
                ""
            )}
            {dialog.dialog_414.open === true ? (
                <>
                    <P414 dialog={dialog} setDialog={setDialog} onGetpCtContractInfo={onGetpCtContractInfo}/>
                </>
            ) : (
                ""
            )}
            {dialog.dialog_415.open === true ? (
                <>
                    <P415 dialog={dialog} setDialog={setDialog} onGetpCtContractInfo={onGetpCtContractInfo}/>
                </>
            ) : (
                ""
            )}
            {dialog.dialog_416.open === true ? (
                <>
                    <P416 dialog={dialog} setDialog={setDialog} onGetpCtContractInfo={onGetpCtContractInfo}/>
                </>
            ) : (
                ""
            )}
            {dialog.dialog_417.open === true ? (
                <>
                    <P417 dialog={dialog} setDialog={setDialog} onGetpCtContractInfo={onGetpCtContractInfo}/>
                </>
            ) : (
                ""
            )}
            <DialogConfirm visible={confirmDialog.open} header={dialogOption.header} modal footer={dialogOption.footerBtn} onHide={() => setConfirmDialog(false)} textContent={dialogOption.content} />
        </>
    );
}
